import { useCallback, useState } from 'react'
import { getSession, register, login, logout, type Session } from './auth'

export interface AuthState {
  session: Session | null
  pending: boolean
  error: string | null
}

export function useAuth() {
  const [state, setState] = useState<AuthState>({ session: getSession(), pending: false, error: null })

  const doRegister = useCallback(async (email: string, password: string, name: string) => {
    setState((s) => ({ ...s, pending: true, error: null }))
    try {
      const session = await register(email, password, name || undefined)
      setState({ session, pending: false, error: null })
    } catch (e) {
      setState((s) => ({ ...s, pending: false, error: e instanceof Error ? e.message : 'Registration failed.' }))
    }
  }, [])

  const doLogin = useCallback(async (email: string, password: string) => {
    setState((s) => ({ ...s, pending: true, error: null }))
    try {
      const session = await login(email, password)
      setState({ session, pending: false, error: null })
    } catch (e) {
      setState((s) => ({ ...s, pending: false, error: e instanceof Error ? e.message : 'Sign-in failed.' }))
    }
  }, [])

  const doLogout = useCallback(async () => {
    await logout()
    setState({ session: null, pending: false, error: null })
  }, [])

  const dismissError = useCallback(() => setState((s) => ({ ...s, error: null })), [])

  return { ...state, register: doRegister, login: doLogin, logout: doLogout, dismissError }
}
